import { FormControlLabelProps, FormControlLabel as MuiFormControlLabel } from '@material-ui/core';
import React from 'react';
import { HeightProps, WidthProps, height, maxHeight, maxWidth, width } from 'styled-system';
import { styled } from '~ui-kit/styled-components';

interface Props {
  label: string;
  checked?: boolean | string;
  disabled?: boolean;
  fontSize?: string;
}

export const FormControlLabelWithImg: React.FunctionComponent<
  Props & FormControlLabelProps & WidthProps & HeightProps
> = ({ control, label, children, ...rest }) => (
  <StyledFormControlLabelWithImg
    {...rest}
    control={control}
    labelPlacement="top"
    label={label}
    classes={{ label: 'label' }}
  />
);

const StyledFormControlLabelWithImg = styled(MuiFormControlLabel)`
  background: ${(props) => (props.checked ? props.theme.colors.primary : '#ffffff')};
  border: 0.75px solid;
  border-color: ${(props) => (props.checked ? '#ffffff' : props.theme.colors.secondaryLight)};
  box-sizing: border-box;
  border-radius: 5px;
  margin-right: 8px !important;
  margin-left: 8px !important;
  ${maxWidth};
  ${maxHeight};
  ${height};
  ${width};

  transition:
    background-color 750ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 750ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 750ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  & .label {
    color: ${(props) => (props.checked ? '#ffffff' : props.theme.colors.secondaryDark)};
    position: relative;
    text-align: center;
    top: 90px;
  }
`;
